exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo[data-v-032885cf]{display:block;width:100%;padding:15px}ons-list-item[data-v-032885cf]{cursor:pointer}a[data-v-032885cf],a[data-v-032885cf]:visited{color:#1f303f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-032885cf","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/base.vue
// module id = 25J5
// module chunks = 0